const ckb = {
  // ── Common ────────────────────────────────────────
  common: {
    save: 'پاشەکەوتکردن',
    cancel: 'پاشگەزبوونەوە',
    delete: 'سڕینەوە',
    create: 'دروستکردن',
    update: 'نوێکردنەوە',
    edit: 'دەستکاری',
    close: 'داخستن',
    confirm: 'دڵنیابوونەوە',
    search: 'گەڕان',
    loading: 'بارکردن...',
    noData: 'هیچ داتایەک نییە',
    actions: 'کردارەکان',
    status: 'دۆخ',
    name: 'ناو',
    description: 'وەسف',
    type: 'جۆر',
    all: 'هەموو',
    active: 'چالاک',
    inactive: 'ناچالاک',
    online: 'سەرهێڵ',
    offline: 'دەرهێڵ',
    idle: 'بێکار',
    back: 'گەڕانەوە',
    logout: 'چوونەدەرەوە',
    darkMode: 'دۆخی تاریک',
    lightMode: 'دۆخی ڕووناک',
    notifications: 'ئاگادارکردنەوەکان',
    version: 'وەشانی 2.1.0',
    language: 'زمان',
    systemsOperational: 'هەموو سیستەمەکان کاردەکەن',
    liveDataConnected: 'داتای ڕاستەوخۆ پەیوەستە',
    skipToContent: 'بازدان بۆ ناوەڕۆکی سەرەکی',
    openNavigation: 'کردنەوەی ڕێنیشاندەر',
    closeNavigation: 'داخستنی ڕێنیشاندەر',
  },

  // ── Auth ──────────────────────────────────────────
  auth: {
    title: 'ئۆمنی ترەیس',
    subtitle: 'چوونەژوورەوە بۆ هەژمارەکەت',
    email: 'ئیمەیڵ',
    password: 'وشەی نهێنی',
    signIn: 'چوونەژوورەوە',
    invalidCredentials: 'زانیاریەکان هەڵەن',
    secureWorkspace: 'شوێنی کاری پارێزراو',
    liveIntelligence: 'زیرەکی ڕاستەوخۆی فلیت',
    heroLine1: 'هەموو ئۆتۆمبێلێک.',
    heroLine2: 'یەک وێنەی ڕوون.',
    heroSubtitle: 'شوێنی ڕاستەوخۆ، تەندروستی فلیت، سەلامەتی شۆفێر و کارەکان بکە بە بڕیاری خێرا.',
    realTimeInsight: 'تێڕوانینی ڕاستەوخۆ',
    secureDesign: 'پارێزراو بە دیزاین',
    brandTagline: 'کارەکانی فلیت، بە جوانی پەیوەستکراون.',
    protectedAccess: 'دەستگەیشتنی کۆدکراو و چاودێری چالاکی',
  },

  // ── Navigation ────────────────────────────────────
  nav: {
    myDevices: 'ئامێرەکانم',
    dashboard: 'داشبۆرد',
    driver: 'شۆفێر',
    identity: 'ناسنامە',
    users: 'بەکارهێنەرەکان',
    roles: 'ڕۆڵەکان',
    devices: 'ئامێرەکان',
    allDevices: 'هەموو ئامێرەکان',
    sensorDefinitions: 'پێناسەکانی هەستەوەر',
    deviceAssignments: 'دیاریکردنی ئامێرەکان',
    digitalTwin: 'دووانەی دیجیتاڵ',
    ruleEngine: 'بزوێنەری یاسا',
    rules: 'یاساکان',
    alerts: 'ئاگاداریەکان',
    liveMap: 'نەخشەی ڕاستەوخۆ',
    tripPlayback: 'دووبارەکردنەوەی گەشت',
    geofences: 'سنووری جوگرافی',
    trips: 'گەشتەکان',
    dispatch: 'ناردن',
    maintenance: 'پاراستن',
    remoteControl: 'کۆنترۆڵی دوور',
    analytics: 'شیکاری',
    notifications: 'ئاگادارکردنەوەکان',
    sendNotification: 'ناردنی ئاگادارکردنەوە',
    trustCircle: 'بازنەی متمانە',
    deviceGroups: 'گرووپەکانی ئامێر',
    billing: 'پارەدان',
    reports: 'ڕاپۆرتەکان',
    security: 'ئاسایش',
    fuelAnalytics: 'شیکاری سووتەمەنی',
    audiences: 'ئاگادارکردنەوەکان',
  },

  // ── Dashboard ─────────────────────────────────────
  dashboard: {
    title: 'داشبۆرد',
    overview: 'تێڕوانینی گشتی تا',
    myAccount: 'هەژمارەکەم',
    devicesCount: 'ئامێرەکان',
    onlineCount: '{{count}} سەرهێڵ',
    usersCount: 'بەکارهێنەرەکان',
    inYourTenant: 'لە ڕێکخراوەکەت',
    activeAlerts: 'ئاگاداریە چالاکەکان',
    recentAlerts: 'دوایین ئاگاداریەکان',
    recentNotifications: 'دوایین ئاگادارکردنەوەکان',
    unreadNotifications: '{{count}} ئاگادارکردنەوەی نەخوێندراوە',
    noAlerts: 'هیچ ئاگاداریەکی نوێ نییە',
    noNotifications: 'هیچ ئاگادارکردنەوەیەکی نوێ نییە',
    deviceStatus: 'دۆخی ئامێر',
    organization: 'ڕێکخراو',
    tenantId: 'ناسنامەی ڕێکخراو',
    plan: 'پلان',
    roles: 'ڕۆڵەکان',
    visibleDevices: 'ئامێرە بینراوەکان',
    online: 'سەرهێڵ',
    idle: 'بێکار',
    parked: 'پارککراو',
    towing: 'هەڵکێشان',
    offline: 'دەرهێڵ',
    total: 'کۆی گشتی',
    leaderboard: 'لیستی باشترین شۆفێرەکان',
    topDrivers: 'باشترین شۆفێرەکان',
    liveOperations: 'کارە ڕاستەوخۆکان',
    welcomeBack: 'بەخێربێیتەوە',
    commandSubtitle: 'فلیتەکەت پەیوەستە. ئەمە ئەو شتانەن کە ئەمڕۆ پێویستیان بە سەرنجە.',
    fleetAvailability: 'ئامادەیی فلیت',
    moving: 'لە جووڵەدایە',
    critical: 'مەترسیدار',
    liveMovement: 'جووڵەی ڕاستەوخۆ دیاریکرا',
    liveVehicleHealth: 'تەندروستی ئۆتۆمبێل و دۆخی پەیوەندی بە ڕاستەوخۆ',
    noTwinData: 'کاتێک ئامێرەکان دەست بە ناردنی زانیاری بکەن دۆخی ڕاستەوخۆ دەردەکەوێت.',
    trackedVehicle: 'ئۆتۆمبێلی شوێنکەوتوو',
    alertsSubtitle: 'ڕووداوەکانی فلیت بەپێی گرنگی',
    clear: 'هەموو شتێک باشە',
    quickActions: 'کردارە خێراکان',
    thisWeek: 'ئەم هەفتەیە',
  },

  // ── Devices ───────────────────────────────────────
  device: {
    title: 'ئامێرەکان',
    subtitle: 'تۆمارکردن و بەڕێوەبردنی ئامێرەکانی IoT',
    register: 'تۆمارکردنی ئامێر',
    editDevice: 'دەستکاری ئامێر',
    registerDevice: 'تۆمارکردنی ئامێر',
    identifier: 'ژمارەی IMEI / زنجیرە',
    deviceType: 'جۆری ئامێر',
    vehicleType: 'جۆری ئۆتۆمبێل',
    phoneNumber: 'ژمارەی تەلەفۆنی SIM',
    timezone: 'ناوچەی کاتی',
    created: 'دروستکراوە',
    info: 'زانیاری ئامێر',
    liveTwinState: 'دۆخی دووانەی ڕاستەوخۆ',
    noLiveData: 'هێشتا داتای ڕاستەوخۆ نییە',
    lastSeen: 'دوایین بینین',
    updated: 'نوێکراوەتەوە',
    latitude: 'پانی',
    longitude: 'درێژی',
    speed: 'خێرایی',
    heading: 'ئاڕاستە',
    altitude: 'بەرزی',
    health: 'تەندروستی ئامێر',
    attachedSensors: 'هەستەوەرە پەیوەستکراوەکان',
    noSensors: 'هیچ هەستەوەرێک پەیوەست نەکراوە',
    fuelRecords: 'تۆمارەکانی سووتەمەنی',
    noFuelRecords: 'هیچ تۆمارێکی سووتەمەنی نییە',
    theftSuspected: 'گومانی دزی',
    cannotChangeId: 'ناتوانرێت ناسنامەکە دوای تۆمارکردن بگۆڕدرێت',
    idHelperText: 'ناسنامەی تایبەتی ئامێر یان IMEI',
    confirmDelete: 'ئەم کارە ئامێرەکە و هەموو داتاکانی بە تەواوی دەسڕێتەوە. ناتوانرێت گەڕێنرێتەوە.',
    gpsTracker: 'بەدوادەچوی GPS',
    vehicleObd: 'ئامێری OBD ی ئۆتۆمبێل',
    assetTracker: 'بەدوادەچوی سامانەکان',
    personal: 'کەسی',
    car: 'ئۆتۆمبێل',
    truck: 'بارهەڵگر',
    van: 'ڤان',
    motorcycle: 'مۆتۆر',
    bus: 'پاس',
    heavyEquipment: 'ئامێری قورس',
    other: 'هیتر',
    none: 'هیچ',
    tripIdleThreshold: 'سنووری بێکاری گەشت (خولەک)',
    tripIdleHelperText: 'خولەکی بێکاری بۆ کۆتایی گەشت (بنەڕەتی ٣٠)',
  },

  // ── Digital Twin ──────────────────────────────────
  twin: {
    title: 'دووانەی دیجیتاڵ',
    subtitle: 'دۆخی ئامێرەکان بە ڕاستەوخۆ — هەر ١٠ چرکە نوێ دەبێتەوە',
    noDeviceTwinData: 'هێشتا داتای دووانەی دیجیتاڵ نییە. داتای هەستەوەر یان GPS بنێرە بۆ بینینی دۆخی ئامێرەکان.',
    health: 'تەندروستی',
  },

  // ── Map ───────────────────────────────────────────
  map: {
    title: 'نەخشەی ڕاستەوخۆ',
    trackedDevices: '{{count}} ئامێری بەدوادەچراو',
    geofenceCount: '{{count}} سنووری جوگرافی',
    searchVehicles: 'گەڕان بۆ ئۆتۆمبێلەکان...',
    noVehicles: 'هیچ ئۆتۆمبێلێک نەدۆزرایەوە',
    fitAllDevices: 'هەموو ئامێرەکان پیشان بدە',
    type: 'جۆر',
    status: 'دۆخ',
    speed: 'خێرایی',
    heading: 'ئاڕاستە',
    seen: 'بینراو',
    location: 'شوێن',
    altitude: 'بەرزی',
    owner: 'خاوەن / شۆفێر',
    vehicleType: 'جۆری ئۆتۆمبێل',
    deviceType: 'جۆری ئامێر',
    phone: 'تەلەفۆن',
    timezone: 'ناوچەی کاتی',
    lastSeen: 'دوایین بینین',
    deviceHealth: 'تەندروستی ئامێر',
    sensorData: 'داتای هەستەوەر',
    follow: 'بەدواداچوون',
    following: 'بەدواداچوون چالاکە',
    openMaps: 'کردنەوە لە نەخشە',
    viewDetails: 'بینینی هەموو وردەکارییەکان',
    unknownDevice: 'ئامێری نەناسراو',
    fullscreen: 'شاشەی تەواو',
    exitFullscreen: 'دەرچوون لە شاشەی تەواو',
    online: 'سەرهێڵ',
    idle: 'بێکار',
    parked: 'پارککراو',
    towing: 'هەڵکێشان',
    offline: 'دەرهێڵ',
  },

  // ── Trip Playback ─────────────────────────────────
  playback: {
    title: 'دووبارەکردنەوەی گەشت',
    subtitle: 'دووبارەکردنەوەی ڕێگای GPS — ئامێری زیاتر و ماوەی کاتی هەڵبژێرە',
    devices: 'ئامێرەکان',
    selectDevices: 'ئامێرەکان هەڵبژێرە...',
    from: 'لە',
    to: 'بۆ',
    points: '{{count}} خاڵ',
    play: 'لێدان',
    pause: 'وەستان',
    restart: 'دەستپێکردنەوە',
    selectSubtitle: 'ئامێرەکان و ماوەی کاتی هەڵبژێرە، پاشان کلیک بکە لەسەر گەشتێک بۆ دووبارەکردنەوەی',
    minStop: 'کەمترین وەستان (خولەک)',
    stops: '{{count}} وەستان',
    stopped: '{{duration}} وەستاو',
    noTripsInRange: 'هیچ گەشتێک لە ماوەکەدا نییە',
    noStopsDetected: 'هیچ وەستانێک نەدۆزرایەوە (کەمترین {{min}} خولەک)',
    tripStart: 'دەستپێکی گەشت',
    tripEnd: 'کۆتایی گەشت',
    arrived: 'گەیشتوو',
    departed: 'ڕۆیشتوو',
    duration: 'ماوە',
    location: 'شوێن',
    fromPrev: 'لە پێشوو',
    openGoogleMaps: 'کردنەوە لە گووگڵ مەپس',
    long: 'درێژ',
    medium: 'مامناوەند',
    short: 'کورت',
    fullscreen: 'شاشەی تەواو',
    exitFullscreen: 'دەرچوون لە شاشەی تەواو',
    longest: 'درێژترین',
  },

  // ── Trips ─────────────────────────────────────────
  trips: {
    title: 'گەشتەکان',
    tripCount: '{{count}} گەشت لە ماوەی هەڵبژێردراو',
    allDevices: 'هەموو ئامێرەکان',
    noTrips: 'هیچ گەشتێک لە ماوەی هەڵبژێردراو نییە. گەشتەکان بە شێوەی خۆکار لە داتای GPS ی ئامێرە بەدوادەچراوەکان دروست دەبن.',
    replay: 'دووبارەکردنەوە',
    completed: 'تەواوبوو',
    active: 'چالاک',
    compare: 'بەراوردکردن',
    comparison: 'بەراوردکردنی گەشتەکان',
    selectTripsToCompare: '٢-٥ گەشت هەڵبژێرە بۆ بەراوردکردن',
  },

  // ── Geofences ─────────────────────────────────────
  geofences: {
    title: 'سنووری جوگرافی',
    zoneCount: '{{count}} ناوچە — لەسەر نەخشەکە بکێشە بۆ دروستکردن',
    drawGeofence: 'کێشانی سنووری جوگرافی',
    drawOnMap: 'سنووری جوگرافی لەسەر نەخشەکە بکێشە',
    noGeofences: 'هێشتا سنووری جوگرافی نییە. کلیک بکە لەسەر "کێشانی سنووری جوگرافی" بۆ دروستکردنی یەکێک.',
    createGeofence: 'دروستکردنی سنووری جوگرافی',
    shapeDrawn: '{{shape}} کێشرا',
    color: 'ڕەنگ',
    radius: 'تیشک',
    pointCount: '{{count}} خاڵ',
    notifyDriver: 'ئاگادارکردنەوەی شۆفێری دیاریکراو لە کاتی چوونەژوورەوە/دەرچوون',
    assignAudience: 'ئاگادارکردنەوەی گروپەکان',
    audienceHint: 'ئەم گروپانە ئاگادارکردنەوە وەردەگرن کاتێک ئامێرێک دەچێتە ناو ئەم ناوچەیە',
  },

  // ── Analytics ─────────────────────────────────────
  analytics: {
    title: 'شیکاری',
    subtitle: 'داتای مێژووی هەستەوەر و شیکاری ڕێگای GPS',
    device: 'ئامێر',
    sensorKey: 'کلیلی هەستەوەر',
    timeRange: 'ماوەی کاتی',
    customRange: 'ماوەی دیاریکراو',
    last1h: 'دوایین 1 کاتژمێر',
    last6h: 'دوایین 6 کاتژمێر',
    last12h: 'دوایین 12 کاتژمێر',
    last24h: 'دوایین 24 کاتژمێر',
    last48h: 'دوایین 48 کاتژمێر',
    last7d: 'دوایین 7 ڕۆژ',
    selectDevice: 'ئامێرێک هەڵبژێرە بۆ دەستپێکردنی شیکاری.',
    speedChart: 'خێرایی بە درێژایی کات',
    sensorChart: 'هەستەوەر: {{key}}',
    gpsTrack: 'ڕێگای GPS',
  },

  // ── Rules & Alerts ────────────────────────────────
  rules: {
    title: 'یاساکان',
    createRule: 'دروستکردنی یاسا',
    editRule: 'دەستکاری یاسا',
    eventType: 'جۆری ڕووداو',
    conditions: 'مەرجەکان (JSON)',
    ruleActions: 'کردارەکان (JSON)',
    noRules: 'هێشتا یاسایەک نییە',
    notifyDriver: 'ناردنی ئاگاداری بۆ شۆفێری دیاریکراو',
  },
  alerts: {
    title: 'ئاگاداریەکان',
    severity: 'ئاستی مەترسی',
    message: 'نامە',
    acknowledge: 'پەسندکردن',
    acknowledged: 'پەسندکراو',
    filterSeverity: 'پاڵاوتنی ئاستی مەترسی',
  },

  // ── Notifications ─────────────────────────────────
  notifications: {
    title: 'ئاگادارکردنەوەکان',
    markAllRead: 'هەموو وەک خوێندراو نیشانە بکە',
    filterUnread: 'نەخوێندراوەکان تەنها',
    noNotifications: 'هیچ ئاگادارکردنەوەیەک نییە',
    deleteConfirm: 'ئەم ئاگادارکردنەوەیە بسڕیتەوە؟',
  },

  sendNotification: {
    title: 'ناردنی ئاگادارکردنەوە',
    subtitle: 'ئاگادارکردنەوەی فوری بنێرە بۆ بەکارهێنەرانی دامەزراوەکەت',
    notificationTitle: 'ناونیشان',
    titlePlaceholder: 'ناونیشانی ئاگادارکردنەوە',
    message: 'نامە',
    messagePlaceholder: 'نامەی ئاگادارکردنەوە بنووسە...',
    severity: 'گرنگی',
    info: 'زانیاری',
    warning: 'ئاگاداری',
    critical: 'گرنگ',
    target: 'وەرگرەکان',
    allUsers: 'هەموو بەکارهێنەرەکان',
    specificUsers: 'بەکارهێنەری دیاریکراو',
    selectUsers: 'بەکارهێنەران هەڵبژێرە',
    send: 'ئاگادارکردنەوە بنێرە',
    sending: 'ناردن...',
    success: 'ئاگادارکردنەوە نێردرا بۆ {{count}} بەکارهێنەر ({{push}} فوری گەیشت)',
    error: 'ناردنی ئاگادارکردنەوە سەرکەوتوو نەبوو',
    noUsers: 'هیچ بەکارهێنەرێک هەڵنەبژێردراوە',
  },

  // ── Fuel ──────────────────────────────────────────
  fuel: {
    title: 'شیکاری سووتەمەنی',
    subtitle: 'بەکارهێنانی سووتەمەنی، تێچووەکان، و دۆزینەوەی دزی',
    totalConsumed: 'کۆی بەکارهێنان',
    totalCost: 'کۆی تێچوو',
    costPerKm: 'تێچوو / کم',
    refillCount: 'جاری پڕکردنەوە',
    theftCount: 'ڕووداوی دزی',
    avgConsumption: 'تێکڕای ل/١٠٠کم',
    selectDevice: 'ئامێرێک هەڵبژێرە بۆ بینینی شیکاری سووتەمەنی',
  },

  // ── Fleet ─────────────────────────────────────────
  fleet: {
    jobs: 'ناردن',
    createJob: 'دروستکردنی کار',
    maintenance: 'پاراستن',
    createSchedule: 'دروستکردنی خشتە',
    commands: 'کۆنترۆڵی دوور',
    issueCommand: 'دەرکردنی فەرمان',
    selectDevice: 'ئامێر هەڵبژێرە',
    commandType: 'جۆری فەرمان',
  },

  // ── Commands ─────────────────────────────────────
  commands: {
    title: 'کۆنترۆڵی دوور',
    subtitle: 'ناردنی فەرمان بۆ ئامێرە بەدوادەچراوەکان',
    totalCommands: 'کۆی فەرمانەکان',
    lock: 'قفڵکردنی ئۆتۆمبێل',
    unlock: 'کردنەوەی قفڵی ئۆتۆمبێل',
    engineDisable: 'ناچالاککردنی بزوێنەر',
    engineEnable: 'چالاککردنی بزوێنەر',
    reboot: 'ڕیستارتکردنی ئامێر',
    lockDesc: 'قفڵکردنی دەرگاکانی ئۆتۆمبێل لە دوورەوە',
    unlockDesc: 'کردنەوەی دەرگاکانی ئۆتۆمبێل لە دوورەوە',
    engineDisableDesc: 'بڕینی هێزی بزوێنەر — ئۆتۆمبێلەکە ناتوانێت دەستپێبکات',
    engineEnableDesc: 'گەڕاندنەوەی هێزی بزوێنەر',
    rebootDesc: 'ڕیستارتکردنی ئامێری بەدوادەچوو',
    confirmDangerous: 'ئەمە کارێکی مەترسیدارە. بزوێنەرەکە ناچالاک دەبێت و ئۆتۆمبێلەکە ناتوانێت دەستپێبکات. دڵنیایت؟',
    queued: 'لە نۆرەدا',
    sent: 'نێردراو',
    acknowledged: 'پەسندکراو',
    failed: 'شکستی هێنا',
    issuedBy: 'دەرکراو لەلایەن',
    issuedAt: 'دەرکراو لە',
    completedAt: 'تەواوبوو لە',
    noCommands: 'هێشتا هیچ فەرمانێک دەرنەکراوە',
    commandSent: 'فەرمانەکە بە سەرکەوتوویی نێردرا',
    commandFailed: 'شکستی هێنا لە ناردنی فەرمان',
  },

  // ── Maintenance ──────────────────────────────────
  maintenance: {
    title: 'پاراستن',
    schedulesConfig: 'خشتەکان و ڕێکخستن',
    serviceOrders: 'فەرمانەکانی خزمەتگوزاری',
    newSchedule: 'خشتەی نوێ',
    task: 'ئەرک',
    everyKm: 'هەر (کم)',
    everyDays: 'هەر (ڕۆژ)',
    noSchedules: 'هێشتا خشتەی پاراستن نییە',
    addCategory: 'زیادکردنی پۆل',
    addType: 'زیادکردنی جۆر',
    categoriesTypes: 'پۆلەکان و جۆرەکان',
    newServiceOrder: 'فەرمانی خزمەتگوزاری نوێ',
    orderTitle: 'ناونیشان',
    description: 'وەسف',
    priority: 'گرنگی',
    serviceType: 'جۆری خزمەتگوزاری',
    odometer: 'ژمارەی کیلۆمەتر (کم)',
    cost: 'تێچوو',
    vendor: 'دابینکەر',
    vendorContact: 'پەیوەندی دابینکەر',
    notes: 'تێبینیەکان',
    status: 'دۆخ',
    open: 'کراوە',
    inProgress: 'لە بەردەوامدا',
    completed: 'تەواوبوو',
    closed: 'داخراو',
    reportIssue: 'ڕاپۆرتکردنی کێشە',
    noServiceOrders: 'هێشتا فەرمانی خزمەتگوزاری نییە',
    noIssues: 'هیچ کێشەیەک ڕاپۆرت نەکراوە',
    issueTitle: 'ناونیشانی کێشە',
    issueSeverity: 'ئاستی مەترسی',
    resolveIssue: 'چارەسەرکردن',
    low: 'نزم',
    normal: 'ئاسایی',
    high: 'بەرز',
    urgent: 'پەلەیی',
  },

  // ── Jobs ─────────────────────────────────────────
  jobs: {
    title: 'ناردن',
    subtitle: 'بەڕێوەبردنی کارەکانی گەیاندن و دیاریکردنی شۆفێرەکان',
    customerName: 'ناوی کڕیار',
    customerPhone: 'ژمارەی تەلەفۆنی کڕیار',
    pickupAddress: 'ناونیشانی وەرگرتن',
    dropoffAddress: 'ناونیشانی گەیاندن',
    assignDriver: 'دیاریکردنی شۆفێر',
    assignVehicle: 'دیاریکردنی ئۆتۆمبێل',
    scheduledAt: 'خشتەبەندکراوە لە',
    priority: 'گرنگی',
    notes: 'تێبینیەکان',
    noJobs: 'هێشتا هیچ کارێک نییە',
    pending: 'چاوەڕوان',
    assigned: 'دیاریکراو',
    accepted: 'پەسەندکراو',
    enRoute: 'لە ڕێگادا',
    inProgress: 'لە بەردەوامدا',
    completed: 'تەواوبوو',
    cancelled: 'هەڵوەشێنرایەوە',
    reference: 'سەرچاوە',
  },

  // ── Billing ───────────────────────────────────────
  billing: {
    title: 'پارەدان و بەکارهێنان',
    subtitle: 'بەڕێوەبردنی بەشداری و پارەدانەکان',
    subscription: 'بەشداری',
    plan: 'پلان',
    expiresIn: 'کۆتایی دێت لە {{days}} ڕۆژ',
    renew30: 'نوێکردنەوە +30 ڕۆژ',
    renew1y: 'نوێکردنەوە +ساڵ',
    usageSummary: 'پوختەی بەکارهێنان',
    paymentSuccess: 'پارەدان سەرکەوتوو بوو!',
    paymentFailed: 'پارەدان شکستی هێنا',
    currentSubscription: 'بەشداری ئێستا',
    pricingTiers: 'ئاستەکانی نرخ',
    configurePlan: 'ڕێکخستنی پلان',
    numberOfDevices: 'ژمارەی ئامێرەکان',
    billingCycle: 'خولی پارەدان',
    monthly: 'مانگانە',
    quarterly: 'سێ مانگانە',
    semiAnnual: 'شەش مانگانە',
    annual: 'ساڵانە',
    price: 'نرخ',
    subscribe: 'بەشداربوون',
    upgrade: 'بەرزکردنەوە',
    processing: 'چارەسەرکردن...',
    selectGateway: 'هەڵبژاردنی شێوازی پارەدان',
    devices: 'ئامێرەکان',
    remainingDays: 'ڕۆژەکانی ماوە',
    noSubscription: 'هیچ بەشداریەکی چالاک نییە',
    planStatus: 'دۆخی پلان',
    deviceUsage: 'بەکارهێنانی ئامێرەکان',
    devicesUsed: '{{used}} لە {{limit}} ئامێر بەکارهاتووە',
    startedAt: 'دەستپێکرا',
    expiresAt: 'بەسەردەچێت',
    daysLeft: '{{days}} ڕۆژ ماوە',
    expired: 'بەسەرچوو',
    walletBalance: 'باڵانسی جزدان',
    recentTransactions: 'مامەڵە کۆتاییەکان',
    noTransactions: 'هێشتا هیچ مامەڵەیەک نییە',
    topup: 'پڕکردنەوە',
    deduction: 'لێبڕین',
    subscriptionPayment: 'بەشداری',
  },

  // ── Trust Circle ──────────────────────────────────
  trustCircle: {
    title: 'بازنەی متمانە',
    subtitle: 'هاوبەشکردنی دەستگەیشتنی ئامێر لە نێوان ڕێکخراوەکاندا',
    accessGranted: 'دەستگەیشتنی دراو',
    accessReceived: 'دەستگەیشتنی وەرگیراو',
    grantAccess: 'دەستگەیشتن بدە',
    revokeAccess: 'دەستگەیشتن هەڵبگرە',
    targetTenant: 'ناسنامەی ڕێکخراوی ئامانج',
    selectDevices: 'ئامێرەکان هەڵبژێرە',
    permissions: 'مۆڵەتەکان',
    expiresAt: 'کۆتایی دێت لە',
    noGranted: 'هیچ دەستگەیشتنێک بە ڕێکخراوی دیکە نەدراوە',
    noReceived: 'هیچ دەستگەیشتنێک لە ڕێکخراوی دیکەوە وەرنەگیراوە',
    accept: 'پەسەندکردن',
    decline: 'ڕەتکردنەوە',
  },

  // ── Users ─────────────────────────────────────────
  users: {
    title: 'بەکارهێنەرەکان',
    subtitle: 'بەڕێوەبردنی بەکارهێنەرەکان لە ڕێکخراوەکەت',
    addUser: 'زیادکردنی بەکارهێنەر',
    editUser: 'دەستکاری بەکارهێنەر',
    assignRole: 'دیاریکردنی ڕۆڵ',
    noRoles: 'بێ ڕۆڵ',
    confirmDelete: 'ئەم کارە بەکارهێنەرەکە بە تەواوی دەسڕێتەوە. ناتوانرێت گەڕێنرێتەوە.',
    email: 'ئیمەیڵ',
    name: 'ناو',
    password: 'وشەی نهێنی',
    role: 'ڕۆڵ',
    detail: 'وردەکاری بەکارهێنەر',
    profile: 'پرۆفایل',
    noUsers: 'هێشتا بەکارهێنەر نییە',
  },
  roles: {
    title: 'ڕۆڵ و مۆڵەتەکان',
    subtitle: 'پێناسەکردنی ڕۆڵەکان و دیاریکردنی مۆڵەتەکان',
    createRole: 'دروستکردنی ڕۆڵ',
    editPermissions: 'دەستکاری مۆڵەتەکان',
    deleteRole: 'سڕینەوەی ڕۆڵ',
    roleName: 'ناوی ڕۆڵ',
    noRoles: 'هێشتا هیچ ڕۆڵێک پێناسە نەکراوە',
    confirmDelete: 'ئەم کارە ڕۆڵەکە بە تەواوی دەسڕێتەوە.',
  },

  // ── Reports ────────────────────────────────────
  reports: {
    title: 'ڕاپۆرتەکان',
    subtitle: 'دروستکردن و خشتەبەندکردن و داگرتنی ڕاپۆرتەکانی ئۆتۆمبێلەکان',
    templates: 'داڕێژەکان',
    schedules: 'خشتەکان',
    history: 'مێژوو',
    generateNow: 'دروستکردن ئێستا',
    generated: 'ڕاپۆرتەکە بە سەرکەوتوویی دروستکرا',
    checkHistory: 'تەبی مێژوو بپشکنە بۆ داگرتن',
    noTemplates: 'هیچ داڕێژەیەکی ڕاپۆرت بەردەست نییە',
    createSchedule: 'دروستکردنی خشتە',
    reportType: 'جۆری ڕاپۆرت',
    frequency: 'دووبارەبوونەوە',
    dateRange: 'ماوەی بەروار',
    filterDevices: 'پاڵاوتنی ئامێرەکان (بەتاڵ بهێڵەوە بۆ هەموو)',
    filterVehicleTypes: 'پاڵاوتن بە جۆری ئۆتۆمبێل',
    emailTo: 'وەرگرەکانی ئیمەیل',
    emailHelperText: 'ناونیشانی ئیمەیل جیاکراوە بە کۆما بۆ گەیاندنی ڕاپۆرت',
    nextRun: 'جاری داهاتوو',
    fileSize: 'قەبارە',
    generatedAt: 'دروستکراو',
    download: 'داگرتن',
  },

  // ── Security ─────────────────────────────────────
  security: {
    title: 'ئاسایش',
    subtitle: 'ڕاستکردنەوەی دوو هەنگاو و ئامێرە متمانەپێکراوەکان',
    twoFactorAuth: 'ڕاستکردنەوەی دوو هەنگاو',
    twoFAEnabled: 'ڕاستکردنەوەی دوو هەنگاو چالاکە',
    twoFANotSetUp: 'ڕاستکردنەوەی دوو هەنگاو دامەزرێندراو نییە',
    enforced: 'ناچاری',
    twoFARequired: 'ڕاستکردنەوەی دوو هەنگاو پێویستە بۆ ڕێکخراوەکەت',
    myTrustedDevices: 'ئامێرە متمانەپێکراوەکانم',
    allTenantDevices: 'هەموو ئامێرەکانی ڕێکخراو',
    deviceName: 'ناوی ئامێر',
    ipAddress: 'ناونیشانی IP',
    lastUsed: 'دوایین بەکارهێنان',
    expiresAt: 'کۆتایی دێت لە',
    revoke: 'هەڵگرتن',
    noDevices: 'هیچ ئامێرێکی متمانەپێکراو نییە',
    changePassword: 'گۆڕینی وشەی نهێنی',
    changePasswordSubtitle: 'وشەی نهێنی بۆ چوونەژوورەوە نوێ بکەرەوە',
    currentPassword: 'وشەی نهێنی ئێستا',
    newPassword: 'وشەی نهێنی نوێ',
    confirmPassword: 'پشتڕاستکردنەوەی وشەی نهێنی نوێ',
    passwordMismatch: 'دوو وشەی نهێنی یەکسان نین',
    passwordTooShort: 'دەبێت وشەی نهێنی لانی کەم ٨ پیت بێت',
    passwordChanged: 'وشەی نهێنی بە سەرکەوتوویی گۆڕدرا',
    passwordChangeFailed: 'نەتوانرا وشەی نهێنی بگۆڕدرێت',
    wrongCurrentPassword: 'وشەی نهێنی ئێستا هەڵەیە',
    save: 'پاشەکەوتکردن',
  },

  // ── Two-Factor ────────────────────────────────────
  twoFactor: {
    title: 'ڕاستکردنەوەی دوو هەنگاو',
    subtitle: 'کۆدەکە لە بەرنامەی ڕاستکردنەوەکەت بنووسە',
    enterCode: 'کۆدی ٦ ژمارەیی بنووسە',
    verify: 'پشتڕاستکردنەوە',
    backToLogin: 'گەڕانەوە بۆ چوونەژوورەوە',
    setupTitle: 'دامەزراندنی ڕاستکردنەوەی دوو هەنگاو',
    scanQR: 'ئەم کۆدی QR ـە بە بەرنامەی ڕاستکردنەوەکەت سکان بکە',
    enterManually: 'یان ئەم نهێنییە بە دەست بنووسە',
    secretKey: 'کلیلی نهێنی',
    confirmCode: 'کۆدەکە بنووسە بۆ دڵنیابوون لە دامەزراندن',
    activate: 'چالاککردنی ڕاستکردنەوەی دوو هەنگاو',
  },

  // ── Device Groups ─────────────────────────────────
  deviceGroups: {
    title: 'گرووپەکانی ئامێر',
    subtitle: 'ڕێکخستنی ئامێرەکان لە گرووپی لۆژیکیدا',
    create: 'دروستکردنی گرووپ',
    noGroups: 'هێشتا گرووپی ئامێر نییە',
    manageGroup: 'بەڕێوەبردنی گرووپ',
    groupName: 'ناوی گرووپ',
    assignDevices: 'دیاریکردنی ئامێرەکان',
    assignUsers: 'دیاریکردنی بەکارهێنەرەکان',
    confirmDelete: 'ئەم کارە گرووپەکە بە تەواوی دەسڕێتەوە.',
  },

  // ── Audience Groups ────────────────────────────────
  audiences: {
    title: 'گروپەکانی ئاگادارکردنەوە',
    subtitle: 'ناردنی ئاگادارکردنەوە بۆ گروپێک لە کەسان کاتێک ڕووداوی ناوچە ڕوودەدات',
    create: 'دروستکردنی گروپ',
    members: 'ئەندامان',
    addMember: 'زیادکردنی ئەندام',
    memberName: 'ناو',
    memberPhone: 'ژمارەی تەلەفۆن',
    platformUser: 'بەکارهێنەری پلاتفۆرم',
    externalContact: 'پەیوەندی دەرەکی',
    externalHint: 'پەیوەندییە دەرەکییەکان واتسئاپ/SMS وەردەگرن کاتێک ناردنی فرەکەناڵ دەست پێدەکات',
    preset: 'قاڵب',
    presetGeneric: 'گشتی',
    presetSchool: 'گواستنەوەی قوتابخانە',
    noGroups: 'هێشتا هیچ گروپێک نییە. یەکێک دروست بکە بۆ دەستپێکردنی ئاگادارکردنەوەکان.',
  },

  // ── Device Assignments ────────────────────────────
  deviceAssignments: {
    title: 'دیاریکردنی ئامێرەکان',
    subtitle: 'کۆنترۆڵکردنی ئەوەی هەر بەکارهێنەرێک کام ئامێر دەبینێت',
    selectUser: 'بەکارهێنەر هەڵبژێرە',
    devicesVisibleTo: 'ئامێرە بینراوەکان بۆ {{user}}',
    noDevices: 'هیچ ئامێرێک دیاری نەکراوە',
  },

  // ── Driver Dashboard ──────────────────────────────
  driver: {
    title: 'داشبۆردی شۆفێر',
    assignedDevices: 'ئامێرە دیاریکراوەکان',
    onlineDevices: 'ئامێرە سەرهێڵەکان',
    recentAlerts: 'دوایین ئاگاداریەکان',
    noAlerts: 'هیچ ئاگاداریەکی نوێ نییە',
  },

  // ── Viewer Dashboard ──────────────────────────────
  viewer: {
    title: 'داشبۆردی بینەر',
    assignedDevices: 'ئامێرە دیاریکراوەکان',
    lastActivity: 'دوایین چالاکی',
  },

  // ── Share Tracking ────────────────────────────────
  share: {
    title: 'بەدواداچوونی ڕاستەوخۆ',
    loading: 'بارکردنی داتای بەدواداچوون...',
    invalidLink: 'لینکی بەدواداچوون نادروست یان بەسەرچوو',
    lastSeen: 'دوایین بینین',
    speed: 'خێرایی',
  },

  // ── Ingestion ─────────────────────────────────────
  ingestion: {
    title: 'هەڵمژینی داتا',
    subtitle: 'هەڵمژینی داتای تێلیمەتری ئامێرەکان',
  },

  // ── Sensor Definitions ────────────────────────────
  sensors: {
    title: 'پێناسەکانی هەستەوەر',
    subtitle: 'پێناسەکردنی جۆرەکانی هەستەوەر و زانیاریەکانیان',
    createSensor: 'دروستکردنی پێناسەی هەستەوەر',
    key: 'کلیل',
    keyLabel: 'کلیل (بۆ نموونە: temperature)',
    keyHelperText: 'ناسنامەی snake_case کە لە داتاکاندا بەکاردێت',
    displayName: 'ناوی نیشاندان',
    unit: 'یەکە',
    unitLabel: 'یەکە (بۆ نموونە: °C, km/h)',
    dataType: 'جۆری داتا',
  },

  // ── Sensor Names ──
  sensorNames: {
    battery_voltage: 'ڤۆڵتی باتری',
    gsm_signal: 'هێڵی GSM',
    acc: 'پێوەری لەزبوون',
    charging: 'چارج',
    speed: 'خێرایی',
    fuel_level: 'ئاستی سووتەمەنی',
    temperature: 'پلەی گەرمی',
    humidity: 'شێ',
    rpm: 'ژمارەی سووڕانەوە',
    odometer: 'ژمارەی کیلۆمەتر',
    engine_load: 'بارگەی بزوێنەر',
    coolant_temp: 'پلەی گەرمی ئاوی ساردکەرەوە',
    door_status: 'دۆخی دەرگا',
    ignition: 'داگیرسان',
    alarm_type: 'جۆری ئاگاداری',
    external_voltage: 'ڤۆڵتی دەرەکی',
    fuel_consumption: 'بەکارهێنانی سووتەمەنی',
    tire_pressure: '��ەستانی تایەر',
    altitude: 'بەرزی',
    heading: 'ئاڕاستە',
    oil_pressure: 'پەستانی زەیت',
    throttle_position: 'شوێنی پێدانەکە',
    transmission_temp: 'پلەی گەرمی گێربۆکس',
    brake_fluid_level: 'ئاستی شلەی بریک',
    abs_status: 'دۆخی سیستەمی ABS',
    airbag_status: 'دۆخی بالشتەکانی هەوا',
    seatbelt_status: 'دۆخی قایشی ئاسایش',
    harsh_braking: 'بریکی توند',
    harsh_acceleration: 'لەزبوونی توند',
    sharp_turn: 'سووڕانەوەی تیژ',
    towing_detected: 'هەڵکێشان دۆزرایەوە',
    crash_detected: 'پێکدادان دۆزرایەوە',
    tamper_alert: 'ئاگاداری دەستدرێژی',
    jamming_detected: 'پارازیت دۆزرایەوە',
  },
}

export default ckb
